import { render, staticRenderFns } from "./leaderindex.vue?vue&type=template&id=52d6be62&scoped=true&"
import script from "./leaderindex.vue?vue&type=script&lang=js&"
export * from "./leaderindex.vue?vue&type=script&lang=js&"
import style0 from "./leaderindex.vue?vue&type=style&index=0&id=52d6be62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6be62",
  null
  
)

export default component.exports